import {useEffect} from "react";

export const useInjectFonts = (fontCssHref) => {

  useEffect(() => {
    if (!fontCssHref) {
      return;
    }

    const PUBLIC_URL = process.env.PUBLIC_URL || "";

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${PUBLIC_URL}${fontCssHref}`;
    document.head.appendChild(link);
    return () => {
      link?.parentNode?.removeChild(link);
    };
  }, [fontCssHref]);
};

export default useInjectFonts;